/**
 * Whether pushing forward looks down.
 *
 * It writes to [lookInversion](../../../core/input/lookInversion.ts), which every control map reads
 * per tick as the sign on its pitch delta. Pitch only: yaw and movement are never inverted, and
 * that module says why.
 *
 * A switch rather than a choice, on the contract's own terms: the setting's whole content is
 * whether one thing happens, and the row is one control the player throws rather than two they
 * compare.
 */

import { DEFAULT_LOOK_Y_INVERTED, setLookYInverted } from '@/core/input/lookInversion';
import { SETTING_INVERT_LOOK_HINT, SETTING_INVERT_LOOK_LABEL } from '@/text/settingsText';
import { toggleApply, toggleValue } from '@/ui/settings/controls/toggleSwitch';
import type { SettingDefinition } from '@/ui/settings/settingContract';

export const INVERT_LOOK_Y: SettingDefinition = {
  id: 'invertLookY',
  section: 'controls',
  label: SETTING_INVERT_LOOK_LABEL,
  hint: SETTING_INVERT_LOOK_HINT,
  control: { kind: 'toggle' },
  defaultValue: toggleValue(DEFAULT_LOOK_Y_INVERTED),
  apply: toggleApply(setLookYInverted),
};
